// extracted by mini-css-extract-plugin
export default {"pager-btn":"Pager_pager-btn__d3z0z","pager-num":"Pager_pager-num__5kw4h"};